<template>
    <u-btn-icon-flat-rounded v-bind="$attrs" @click="$emit('click')">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-btn-icon-flat-rounded>
</template>

<script>
import UBtnIconFlatRounded from "@/components/publish/styles/buttons/u-btn-icon-flat-rounded.vue";

export default {
    props: {},
    components: {
        UBtnIconFlatRounded,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
